export const planDetailsContent = {
  ctaDataItemName: 'how-it-works-order',
  ctaViewAll: 'View all plans',
  ctaViewAllDataName: 'pdp-view-all-plans',
  quoteText:
    'Simple, fast and effective. Everything is exactly as advised: no surprises or hidden costs',
  quoteSource: 'Alfredo',
  ctaOrderSim: (planName: string) => `Order your ${planName} SIM in minutes`,
  commitmentFreeTitle: 'Commitment-free SIM plan',
}
